import React, { FC } from "react";
import { Button } from "@chakra-ui/react";
import { useSelectedClassroomStore } from "@/stores/v2/selectedClassroomStore";
import { useClassroomSessionStore } from "@/stores/v2/classroomSessionStore";
import p2pManager from "@/js/utils/p2pManager";
import { withRouter } from "@/js/components/Root/withRouter";
import { useTranslation } from "react-i18next";

interface Props {
	classroomName: string;
	isMonitoringClass: boolean;
	router: IComponentRouter;
}

const EndClassButton: FC<Props> = (props) => {
	const { t } = useTranslation();
	const classroomId = useSelectedClassroomStore((state) => state.id);

	const handleEndSession = () => {
		void p2pManager.deleteXirsysChannel().catch(); // error already logged in deleteXirsysChannel
		p2pManager.close();
		if (props.isMonitoringClass) {
			void useClassroomSessionStore.getState().handleStartClassSession({
				classroomId: classroomId as string,
				expiry: 0,
				router: props.router,
				force: false,
				inClassroom: false,
				classroomName: props.classroomName,
			});
		} else {
			void useClassroomSessionStore.getState().handleStartClassSession({
				classroomId: classroomId as string,
				expiry: 0,
				router: props.router,
				classroomName: props.classroomName,
			});
		}
	};

	return (
		<Button onClick={handleEndSession} py={0} px={4} ml={3} height={"32px"}>
			{t("classroomDetails.endSession")}
		</Button>
	);
};

export default withRouter(EndClassButton);
